module.exports = __webpack_public_path__ + "img/flask-round-poison.1d0de97d.svg";